var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserslCircle = function SvgUserslCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.555 5.348A8 8 0 0 1 12 4a8.009 8.009 0 0 1 8 8A8 8 0 1 1 7.555 5.348zm7.714.839A6.661 6.661 0 0 0 12 5.333a6.66 6.66 0 0 0-5.922 9.718.168.168 0 0 0 .19.084.167.167 0 0 0 .065-.034 4.656 4.656 0 0 1 6.782.831.167.167 0 0 0 .266.005A3.33 3.33 0 0 1 16 14.667c.593 0 1.175.162 1.684.466a.167.167 0 0 0 .233-.066 6.661 6.661 0 0 0-2.648-8.88zm-8.436 4.646a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0zm7.167 1.5a2 2 0 1 0 4 0 2 2 0 0 0-4 0z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserslCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "usersl-circle.9553b919836aa0d4a03d224c9856bfcc.svg";